import { Component, Prop, Vue } from 'vue-property-decorator'
import BillingCardComponent from '@/modules/billing-module/shared/components/card/billing-card.vue'
import { InvoiceResponse } from '@/api/services/billing/common-invoice/billing-common-invoice.dto'
import { InvoicePaymentResponse, InvoicePaymentStatus } from '@/api/services/billing/invoice-payment/billing-invoice-payment.dto'
import { Nullable, StrictNullable } from '@/shared/types/app.types'

@Component({
    components: {
        BillingCardComponent
    }
})
export default class BillingModalInvoicePaymentCard extends Vue {
    @Prop({ type: Object }) readonly invoice!: Nullable<InvoiceResponse>
    @Prop({ type: Object }) readonly invoicePayment!: Nullable<InvoicePaymentResponse>

    get title(): string {
        return this.invoicePayment?.label ? `${this.invoicePayment.label} - ${this.$tc('accounting.field.invoice')} ${this.invoicePayment.invoice.label}` : '-'
    }

    get statusName(): string | undefined {
        return this.invoicePayment?.status.translatedName
    }
    get statusClass(): StrictNullable<string> {
        if (this.invoicePayment) {
            switch (this.invoicePayment.status.code) {
            case InvoicePaymentStatus.GENERATED:
                return 'state-primary'
            case InvoicePaymentStatus.CANCELLED:
                return 'state-archived'
            case InvoicePaymentStatus.VERIFIED:
                return 'state-success'
            }
        }
        return null
    }

    get customerName(): string | undefined {
        let customer = this.invoicePayment?.customer
        if (!customer && !!this.invoice) {
            customer = this.invoice.customer
        }
        return customer?.name
    }

    get dateLabel(): string {
        if (this.invoicePayment) {
            switch (this.invoicePayment.status.code) {
            case InvoicePaymentStatus.GENERATED:
                return 'accounting.field.generationDate'
            case InvoicePaymentStatus.CANCELLED:
                return 'accounting.field.cancellationDate'
            case InvoicePaymentStatus.VERIFIED:
                return 'accounting.field.verificationDate'
            }
        }
        return 'accounting.field.generationDate'
    }
    get dateValue(): StrictNullable<string> {
        if (this.invoicePayment) {
            switch (this.invoicePayment.status.code) {
            case InvoicePaymentStatus.GENERATED:
                return this.invoicePayment.generationDate
            case InvoicePaymentStatus.CANCELLED:
                return this.invoicePayment.cancellationDate
            case InvoicePaymentStatus.VERIFIED:
                return this.invoicePayment.verificationDate
            }
        }
        return null
    }

    get responsibleLabel(): string {
        if (this.invoicePayment) {
            switch (this.invoicePayment.status.code) {
            case InvoicePaymentStatus.GENERATED:
                return 'accounting.field.generationResponsible'
            case InvoicePaymentStatus.CANCELLED:
                return 'accounting.field.cancellationResponsible'
            case InvoicePaymentStatus.VERIFIED:
                return 'accounting.field.verificationResponsible'
            }
        }
        return 'accounting.field.generationResponsible'
    }

    get responsibleName(): string {
        if (this.invoicePayment) {
            switch (this.invoicePayment.status.code) {
            case InvoicePaymentStatus.GENERATED:
                return this.invoicePayment.generator?.fullName ?? '-'
            case InvoicePaymentStatus.CANCELLED:
                return this.invoicePayment.canceller?.fullName ?? '-'
            case InvoicePaymentStatus.VERIFIED:
                return this.invoicePayment.verifier?.fullName ?? '-'
            }
        }
        return '-'
    }

    get accountingUnitSymbol(): string {
        return this.invoicePayment?.invoiceAccountingUnit?.symbol ?? '-'
    }

    get conceptsTotalValue(): number {
        if (this.invoicePayment) {
            return this.invoicePayment.conceptsRealTotalValue ?? 0
        }
        return this.invoice?.conceptsTotalValue ?? 0
    }
}
